import { ComponentData } from 'common/models/utilitymodels/list.model';
import { BaseDataModel, BaseMetaModel } from '../../models/utilitymodels/base.model';
import { BaseDataService } from './basedata.service';
import { SystemService } from './system.service';

export abstract class BaseWidgetService<T extends BaseDataModel> {
    constructor(public baseDataService: BaseDataService<T>, public SystemService: SystemService) {}
    public abstract getMetaModel(): BaseMetaModel;

    prepareAPIErrorMessage(data: any) {
        if (Object.keys(data).length === 1 && Object.keys(data)[0] === 'Error') {
            return data['Error'];
        } else if (data.status && data.status === 'Failed') {
            return data.error;
        } else {
            return null;
        }
    }

    getDataModel() {
        return new Promise((resolve, reject) => {
            resolve(this.baseDataService.dataModel());
        });
    }

    preFillDataModel(data: any) {
        return new Promise((resolve, reject) => {
            resolve(this.baseDataService.prefillDataModel(data));
        });
    }

    async getBlankObject(): Promise<T> {
        return await new Promise<T>((resolve, reject) => {
            const instance = this.baseDataService.dataModel();
            resolve(instance);
        });
    }

    getDataById(params: any[]): Promise<any> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.baseDataService.getDatafromAPI(params);
                })
                .then((apiRes) => {
                    resolve(this.prapareDataModel(apiRes));
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getListDataModel(params: any[]): Promise<T[]> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.baseDataService.getDatafromAPI(params);
                })
                .then((listResponse) => {
                    resolve(listResponse);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    postDatatoAPI(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.baseDataService
                .postDatatoAPI(data)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    prapareDataModel(apiRes: any): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const instance = this.baseDataService.dataModel();
            resolve(instance);
        });
    }

    getBackPageDataModel(): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve(null);
        });
    }

    prepareMetaModel(dataModel: BaseDataModel, metaModel: BaseMetaModel, routeData: ComponentData): Promise<BaseMetaModel> {
        return new Promise<BaseMetaModel>((resolve, reject) => {
            resolve(metaModel);
        });
    }
}
